/*--------------------------------------------------------------------------------
On Load
--------------------------------------------------------------------------------*/
jQuery(window).load(function() {
	

});


/*--------------------------------------------------------------------------------
General Ready
--------------------------------------------------------------------------------*/
( function( $ ) {
$(document).ready(function(){


	$('.nav-foldout .menu-item-has-children > a').click(function(e) {
		e.preventDefault();
		$(this).parent().toggleClass('open');
	})

	$('#header-navicon').click(function(e){
		e.preventDefault();
		$(this).toggleClass('open');
		$('#nav-foldout').toggleClass('open');

	});
		

});
} )( jQuery );